"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackUserFeedbackEvent = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackUserFeedbackEvent({ eventAction, eventLabel, nonInteraction, eventData, }) {
    const event = {
        event: 'JS_Event',
        eventCategory: 'Feedback',
        eventAction,
        eventLabel,
        nonInteraction,
        ...(eventData ? { eventData } : undefined),
    };
    (0, pushToDataLayer_1.pushToDataLayer)(event);
}
exports.trackUserFeedbackEvent = trackUserFeedbackEvent;
//# sourceMappingURL=trackUserFeedbackEvent.js.map